import { getGlobals } from './globals';

const getTrackingVersion = () => {
    return getGlobals()?.trackingVersion;
};

const isV3 = () => {
    const trackingVersion = getTrackingVersion();

    return trackingVersion === 'v3';
};

const isV4 = () => {
    const trackingVersion = getTrackingVersion();

    return trackingVersion === 'v4';
};

export { getTrackingVersion, isV3, isV4 };
